import React from 'react'
import { MainContent } from 'styles/algolia'
import { Layout } from '../components/styles'
import Header from './Header'
import Breadcrumb from '../components/Breadcrumb'
import CollectionsList from '../components/collections/CollectionsList'
import NewThisWeekList from '../components/newThisweek/NewThisweekList'
import NavTabs from '../components/navPanel/NavTabs'
import LoadMoreButton from '../components/LoadMoreButton'
import NewThisWeekHeader from './NewThisWeekHeader'
export default (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <>
      <Layout>
        <Breadcrumb />
        <Header />
        <NewThisWeekHeader />
        <NewThisWeekList />
        <NavTabs />
        <MainContent>
          <CollectionsList />
        </MainContent>
        <LoadMoreButton />
      </Layout>
    </>
  )
}